import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Weblink',
  moduleId: MODULE_ID, //Used as vuex store module path
  api: 'weblinks',

  routeHandler,
};

export default module;
